import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { ButtonModule } from "primeng/button";
import { CheckboxModule } from "primeng/checkbox";
import { TooltipModule } from "primeng/tooltip";

@Component({
  selector: "app-order-review",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    CheckboxModule,
    ButtonModule,
    TooltipModule,
  ],
  templateUrl: "./review.component.html",
  styleUrl: "./review.component.scss",
})
export class OrderReviewComponent {
  termsAccepted: boolean = false;
  constructor(private router: Router) {}
  submitOrder() {
    if (this.termsAccepted) {
      console.log("Order Submitted");
    } else {
      alert("Please accept the terms and conditions.");
    }
  }
}
